/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
};
export default {
  //文件上传（统一走 cloud 七牛上传）
  detailTask: {
    uploadUrl: `${base.url}/cloud/qiniuUpload/upload`
  },
  //客户查询
  common: {
    configKey: `${base.url}/business/sysParam/key`
  },
  //客户查询
  miUser: {
    query: `${base.url}/business/miUser/list`,
    addOrUpdate: `${base.url}/business/miUser/addOrUpdate`,
    deleteBatchIds: `${base.url}/business/miUser/deleteBatchIds`,
    status: `${base.url}/business/miUser/status`
  },
  //签到接口
  userSignIn: {
      query: `${base.url}/business/sign/list`,
      addOrUpdate: `${base.url}/business/sign/addOrUpdate`,
      deleteBatchIds: `${base.url}/business/sign/deleteBatchIds`,
    },
  //日签到统计接口
  signDaily: {
    query: `${base.url}/business/signDaily/list`
  },
    //月签到统计接口
  signMonth: {
    query: `${base.url}/business/signMonth/list`
  },
  //邀请接口
  userInvite: {
    query: `${base.url}/business/invite/list`

  },
  //邀请统计接口
  inviteStat: {
    query: `${base.url}/business/inviteStat/list`
  },

          //广告管理
          adConfig: {
            query: `${base.url}/business/adConfig/list`,
            addOrUpdate: `${base.url}/business/adConfig/addOrUpdate`,
            approved: `${base.url}/business/adConfig/approved`,
            deleteBatchIds: `${base.url}/business/adConfig/deleteBatchIds`,
            status: `${base.url}/business/adConfig/status`,
          },

             //消息配置
             pushMsgConfig: {
             query: `${base.url}/business/pushMsgConfig/list`,
             addOrUpdate: `${base.url}/business/pushMsgConfig/addOrUpdate`,
             deleteBatchIds: `${base.url}/business/pushMsgConfig/deleteBatchIds`,
      },
              //模版配置
              templateMsg: {
                query: `${base.url}/business/innerTemplateMsg/list`,
                addOrUpdate: `${base.url}/business/innerTemplateMsg/addOrUpdate`,
                deleteBatchIds: `${base.url}/business/innerTemplateMsg/deleteBatchIds`,
                   status: `${base.url}/business/innerTemplateMsg/status`
         },

        //短信模版配置
         smsMessageTemplate: {
          query: `${base.url}/business/sms/messageTemplate/list`,
          addOrUpdate: `${base.url}/business/sms/messageTemplate/addOrUpdate`,
          deleteBatchIds: `${base.url}/business/sms/messageTemplate/deleteBatchIds`,
          status: `${base.url}/business/sms/messageTemplate/status`
   },
          //短信记录配置
        smsMessageLog: {
          query: `${base.url}/business/sms/messageLog/list`,
          addOrUpdate: `${base.url}/business/sms/messageLog/addOrUpdate`,
          deleteBatchIds: `${base.url}/business/sms/messageLog/deleteBatchIds`,
      },

           //公告配置
           noticePushMsg: {
            query: `${base.url}/business/noticePushMsg/list`,
            addOrUpdate: `${base.url}/business/noticePushMsg/addOrUpdate`,
            deleteBatchIds: `${base.url}/business/noticePushMsg/deleteBatchIds`,
            back: `${base.url}/business/noticePushMsg/back`,
        },


          //APP版本管理
          appVersion: {
           query: `${base.url}/business/appVersion/list`,
           addOrUpdate: `${base.url}/business/appVersion/addOrUpdate`,
           deleteBatchIds: `${base.url}/business/appVersion/deleteBatchIds`,
           status: `${base.url}/business/appVersion/status`,
              copy: `${base.url}/business/appVersion/copy`
    },
    //APP升级管理
    appUpdate: {
     query: `${base.url}/business/appUpdate/list`,
     addOrUpdate: `${base.url}/business/appUpdate/addOrUpdate`,
     deleteBatchIds: `${base.url}/business/appUpdate/deleteBatchIds`,
     status: `${base.url}/business/appUpdate/status`,
     //根据平台查询版本列表
     platformList: `${base.url}/business/appVersion/platform/list`
}
};

